import { useState } from 'react';
import { EppSupportOrServiceAnnouncement } from './EppSupportOrServiceAnnouncement.js';
import { EppSupportOrServiceRequestForm } from './EppSupportOrServiceRequestForm.js';
import type { DamageDescriptionTypes } from './EppSupportOrServiceAnnouncement.js';
import type { CompanyInfoResponse, Subscription } from '../../generated/api/models.js';

interface EppSupportOrServiceRequestProps {
  isEmployee: boolean;
  onCancel: () => void;
  subscription: Subscription;
  companyInfo?: CompanyInfoResponse;
}

export const EppSupportOrServiceRequest = ({
  isEmployee,
  onCancel,
  subscription,
  companyInfo,
}: EppSupportOrServiceRequestProps) => {
  const [announcementConfirmed, setAnnouncementConfirmed] = useState(false);
  const [damageDescriptionType, setDamageDescriptionType] = useState<DamageDescriptionTypes | undefined>(undefined);

  return announcementConfirmed ? (
    <EppSupportOrServiceRequestForm
      isEmployee={isEmployee}
      onCancel={onCancel}
      subscription={subscription}
      companyInfo={companyInfo}
      damageDescriptionType={damageDescriptionType}
    />
  ) : (
    <EppSupportOrServiceAnnouncement
      isEmployee={isEmployee}
      onCancel={onCancel}
      onNext={() => setAnnouncementConfirmed(true)}
      onChangeDamageDescriptionType={setDamageDescriptionType}
    />
  );
};
